<template>
    <div>
        <v-dialog v-model="$store.getters.pricingHistory"
                  persistent
                  max-width="950">

            <v-card>

                <v-card-title
                        class="headline primary white--text"
                        primary-title>
                    Ιστορικό Κοστολόγησης
                    <v-spacer/>
                    <v-icon color="white" @click="closeModal" >close</v-icon>
                </v-card-title>

                <v-card-text class="mt-2 mb-2">
                    <v-row>
                        <v-col cols="12">
                            <v-toolbar  rounded color="primary" >
                                <v-row>
                                    <v-col cols="3">
                                        <v-chip color="white" outlined class="mr-2 mt-5">{{this.selectedBookId}}</v-chip>
                                    </v-col>
                                    <v-col class="mb-5" cols="9">
                                        <v-chip id="bookTitle" style="text-wrap: normal" color="white" outlined class="mt-5" >
                                            <span class="text-truncate">{{this.bookTitle}}</span>
                                        </v-chip>
                                    </v-col>

                                </v-row>

                            </v-toolbar>
                        </v-col>
                    </v-row>

                    <v-data-table
                            no-data-text="Δεν υπάρχουν δεδομένα."
                            :headers="headers"
                            :items="items"
                            :items-per-page="5"
                            sort-by.sync="year"
                            :sort-desc=sortDesc
                            sort-by="year"
                            class="elevation-1">
                        <template v-slot:item="{ item }">
                            <tr >
                                <td class="text-center d-sm-table-cell d-flex">{{ item.year }}</td>
                                <td class="text-center d-sm-table-cell d-flex">{{item.finalSaveTime}}</td>
                                <td class="text-center d-sm-table-cell d-flex">
                                    <v-icon color="primary" @click="openPricing(item)" >mdi-magnify</v-icon>
                                </td>
                                <td class="text-center d-sm-table-cell d-flex">
                                    <v-tooltip v-if="item.applicantType===0" top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" color="info" >person</v-icon>
                                        </template>
                                        <span >Εκδότης</span>
                                    </v-tooltip>
                                    <v-tooltip v-else top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" color="#0D47A2"> people </v-icon>
                                            <v-icon v-on="on" color="#CBA053"> euro_symbol</v-icon>
                                        </template>
                                        <span >Επιτροπή Κοστολόγησης</span>
                                    </v-tooltip>

                                </td>
                                <td style="min-width: 24ch" v-if="item.applicantType!==0" class="text-center d-sm-table-cell d-flex">
                                    <p class="pt-3" v-if="item.status.status === 'REJECTED'">Απορρίφθηκε</p>
                                    <p class="pt-3" v-if="item.status.status === 'COMMITTEE_PRICE_APPROVED'">Εγκρ. τιμής επιτροπής</p>
                                    <p class="pt-3" v-if="item.status.status === 'PUBLISHER_PRICE_APPROVED'">Εγκρ. τιμής εκδότη</p>
                                </td>
                                <td v-else class="text-center d-sm-table-cell d-flex">
                                    {{'--'}}
                                </td>
                                <td v-if="item.applicantType!==0 && item.status.status === 'COMMITTEE_PRICE_APPROVED'" class="text-center d-sm-table-cell d-flex">
                                    <v-icon @click="openObjectionDialog(item)" color="indianRed" >mdi-scale-balance</v-icon>
                                </td>
                                <td v-else class="text-center d-sm-table-cell d-flex">
                                    {{'--'}}
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            text
                            @click="closeModal">
                        Κλείσιμο
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="objectionDialog"
                  persistent
                  max-width="900">
            <v-card>

                <v-card-title
                        class="headline primary white--text"
                        primary-title>
                    Κείμενο Ένστασης
                    <v-spacer/>
                    <v-icon color="white" @click="closeObjectionDialog" >close</v-icon>
                </v-card-title>

                <v-card-text class="mt-2 mb-2">
                    <v-row justify="center">
                        <v-col cols="12">
                            <v-textarea filled v-model="objectionTextInput" />
                        </v-col>
                    </v-row>


                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions style="justify-content: center">
                    <v-btn style="min-width: 150px" @click="closeObjectionDialog()">
                        Άκυρο
                    </v-btn>

                    <v-btn :disabled="objectionTextInput==='' || objectionTextInput===null || objectionTextInput===undefined" style="min-width: 150px" color="primary" @click="submitObjection">
                        Αποθήκευση
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
     import {eventBus} from "../../../main";
    import requests from "../../../requests";
    import utils from "../../../utilities";
    export default {
        name: "PricingHistoryDialog",
        data: () => ({
            headers: [
                { text: 'Έτος', value: 'year', align: 'center',width: '5%' },
                { text: 'Ημ/νία Ορ. Υποβολής', value: 'finalSaveTime', align: 'center',width: '20%' },
                { text: 'Προβολή', value: 'click', align: 'center',width: '5%' },
                { text: 'Πραγματοποιήθηκε από', align: 'center',width: '15%' },
                { text: 'Κατάσταση', align: 'center',width: '50%' },
                { text: 'Υποβολή Ένστασης', value: 'bal',align: 'center' ,width: '5%' },
            ],
            items:[],
            objectionDialog:false,
            objectionTextInput:'',
            selectedItemForObjection:{},
            sortDesc:true,
            pricingModalKey:0,
            pricingObjForPricingDialog:{},

        }),

        props: {
            selectedBookId: Number,
            bookTitle: String
        },

        methods:{

            openObjectionDialog(item){
                document.activeElement.blur();
                this.selectedItemForObjection = item;
                this.objectionTextInput = item.objectionText;
                this.objectionDialog = true;
            },

            submitObjection(){
                if(window.confirm('Πρόκειται να υποβάλετε ένσταση. Είστε σίγουρος/η;')) {
                    this.selectedItemForObjection.objectionText = this.objectionTextInput;
                    this.$store.commit('setLoadingModal', true);
                    requests.put('rest/pricing/objection', this.selectedItemForObjection, this.submitObjectionCallBack);
                }
            },

            submitObjectionCallBack(){
                this.objectionTextInput = '';
                requests.put('rest/pricing/history', this.selectedBookId, this.getPricingHistoryCallBack);
                utils.setSuccessPopup('Η ένσταση καταχωρήθηκε επιτυχώς', true);
                this.closeObjectionDialog();
            },

            closeObjectionDialog(){
                this.objectionTextInput = '';
                this.objectionDialog =false;
            },


            closeModal(){
                this.$store.commit('setPricingHistory', false);
            },

            getPricingHistoryCallBack(response){
                if(response)
                    this.items = response;

                this.$store.commit('setLoadingModal', false);
            },


            openPricing(item) {
                item.readOnly = true;
                this.pricingObjForPricingDialog = JSON.parse(JSON.stringify(item));
                eventBus.$emit('OpenPricingDialogFromHistory', item); // emit to BookEdit.vue to open the dialog
            },

        },

        created() {
            if(this.selectedBookId){
                this.$store.commit('setLoadingModal', true);
                requests.put('rest/pricing/history', this.selectedBookId, this.getPricingHistoryCallBack);
            }

        },
    }
</script>

<style scoped>

</style>